import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import Post from '@/views/shared/communities/components/Post.vue'
import Navbar from '@/views/shared/communities/components/NavBar.vue'
import MessageBoard from '@/views/shared/communities/components/MessageBoard.vue'
import CreatePostModal from '@/views/shared/communities/components/CreatePostModal.vue'
import EditPostModal from '@/views/shared/communities/components/EditPostModal.vue'
import LikeModal from '@/views/shared/communities/components/LikeModal.vue'
import InterestModal from '@/views/shared/communities/components/InterestModal.vue'
import CreateCommentModal from '@/views/shared/communities/components/CreateCommentModal.vue'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import DeleteCommentSuccessModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'
import DeletePostModal from '@/views/shared/communities/components/DeletePostModal.vue'
import DeletePostSuccessModal from '@/views/shared/communities/components/DeletePostSuccessModal.vue'
import NoPost from '@/views/shared/communities/components/NoPost.vue'
import NoResultFound from '@/views/shared/communities/components/NoResultFound.vue'
import PostSkeleton from '@/components/skeletons/PostSkeleton.vue'

import { computed, ComputedRef, onMounted, onUnmounted, ref, watch } from 'vue-demi'
import postService from '@/services/post.services'
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, POST_STORE } from '@/store/constants'
import { isEqual, pick } from 'lodash'
import { Modal } from 'bootstrap'
import InterestConfirmModal from '@/views/shared/communities/components/InterestConfirmModal.vue'
import { PostType } from '@/store/modules/post'
import MessageModal from '@/views/shared/communities/components/MessageModal.vue'
import { MODAL_ID } from '@/constants/common'
import { translate } from '@/languages/i18n'
import { AxiosError } from 'axios'
import { RECORD_NOT_FOUND, POST_COMMUNITY_SITE_NOT_FOUND } from '@/constants'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useToast } from 'vue-toastification'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const toast = useToast()
const store = useStore()

const postsData = computed<ComputedRef>(() => store.getters[POST_STORE.GETTERS.POSTS])

const currentPostId = ref<string>()

const page = ref<number>(1)

const observer = ref()

const lastPost = ref<HTMLElement>()

const loadingLike = ref<boolean>(false)

const paramGetPost = ref()

const nextPostToken = ref()

const deleteTargetPostId = ref<string>()

const deleteTargetPostCommentId = ref<string>()

const deleteTargetCommentPublished = ref<boolean>()

const modalDeleteCommentSuccess = ref()
const commentIsDelete = ref(true)
const listUser = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])

const interestConfirmModal = ref()

const setCurrentPost = (id: string) => {
  currentPostId.value = id
}

// 2022/11/12 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
const getPosts = async (change) => {
  postsData.value.loadingPosts = true
  if (!route?.params?.id) return
  paramGetPost.value = {
    change,
    community_id: route?.params?.id,
    params: {
      ...route?.query,
      // 2022/11/14 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
      next_post_token: nextPostToken.value,
    },
  }

  await store.dispatch(POST_STORE.ACTIONS.GET_POSTS, paramGetPost.value)
  postsData.value.loadingPosts = false
}

const getListUser = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}

const showInterestConfirmModal = (post: PostType) => {
  interestConfirmModal.value.showDialog(post)
}

const handleLikeOrInterest = async (type, post) => {
  // 2022/09/13 TienNV Fix double click button interest SF10
  loadingLike.value = true
  try {
    const likeOrInterestPostRes =
      type === 'interest'
        ? post.interest
          ? await postService.disInterestPost(post.id)
          : await postService.interestPost(post.id)
        : post.like
        ? await postService.disLikePost(post.id, { from_sf_10: post.content_type === 5 })
        : await postService.likePost(post.id, { from_sf_10: post.content_type === 5 })
    if (likeOrInterestPostRes.data?.success) {
      if (type === 'interest') {
        new Modal(document.getElementById(MODAL_ID.INTEREST_COMPLETE))?.show()
      }

      const newPost = postsData.value.posts.find((e) => e.id === post.id)
      newPost[`${type}_count`] = newPost[type] ? (newPost[`${type}_count`] ?? 0) - 1 : (newPost[`${type}_count`] ?? 0) + 1
      newPost[type] = !newPost[type]

      store.dispatch(POST_STORE.ACTIONS.UPDATE_POST, newPost)
      setTimeout(() => {
        loadingLike.value = false
      }, 500)
    } else {
      // Prevent cases of resource has been deleted before but user still can
      // interact with its reference --> api can't found resource --> redirect user to 404 page
      const errorResponse = (likeOrInterestPostRes as unknown as AxiosError).response
      if (!errorResponse?.data?.success && errorResponse?.data?.data[0]?.status === 404 && errorResponse?.data?.data[0]?.message_code === POST_COMMUNITY_SITE_NOT_FOUND) {
        if (post.content_type === 5) {
          setTimeout(() => {
            loadingLike.value = false
          }, 500)
        } else {
          // Show toast
          toast.error({
            component: ErrorToast,
            props: {
              messageCode: 'OF10errorStatusHasChange',
            },
          })
          // Remove from list
          await store.dispatch(POST_STORE.ACTIONS.REMOVE_POST, { postId: post.id })
        }
      }
    }
  } catch (error) {
    console.log(error)
    loadingLike.value = false
  }
}

const showDeleteCommentSuccessModal = (isDelete) => {
  commentIsDelete.value = isDelete
  modalDeleteCommentSuccess.value.show()
}

const setCommentData = (post_id, id, published) => {
  deleteTargetPostId.value = post_id
  deleteTargetPostCommentId.value = id
  deleteTargetCommentPublished.value = published
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      // 2022/11/15 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
      nextPostToken.value = postsData.value.next_post_token
      if (!nextPostToken.value || postsData.value.posts.length === 0) return
      getPosts(false)
    }
  })

  if (lastPost.value) {
    observer?.value?.observe(lastPost.value)
  }

  const elementDeleteCommentSuccessModal = document.getElementById('deleteCommentSuccess')
  modalDeleteCommentSuccess.value = new Modal(elementDeleteCommentSuccessModal)
})

onMounted(() => {
  getPosts(false)
  getListUser()
})

watch(
  () => lastPost.value,
  () => {
    if (lastPost.value) {
      observer?.value?.observe(lastPost.value)
    }
  }
)

watch(
  () => route.query,
  (newPr, oldPr) => {
    const tempOld = pick(oldPr, 'content_type', 'favorite', 'my_post', 'keyword')
    const tempNewPr = pick(newPr, 'content_type', 'favorite', 'my_post', 'keyword')
    if (newPr && !isEqual(tempOld, tempNewPr) && ['community home', 'alumni home'].includes(route.name)) {
      // 2022/11/14 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
      nextPostToken.value = ''
      getPosts(true)
    }
  },
  { deep: true }
)

onBeforeRouteLeave(() => {
  store.dispatch(POST_STORE.ACTIONS.REMOVE_ALL_POST)
})

onUnmounted(() => {
  observer.value?.disconnect()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createVNode(MessageBoard),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postsData).posts, (post) => {
      return (_openBlock(), _createElementBlock("div", {
        key: post.id
      }, [
        _createVNode(Post, {
          onSetCommentData: setCommentData,
          onSetCurrentPost: setCurrentPost,
          post: post,
          handleLikeOrInterest: handleLikeOrInterest,
          loadingLike: loadingLike.value,
          handleInterestClick: showInterestConfirmModal,
          listUser: _unref(listUser)
        }, null, 8, ["post", "loadingLike", "listUser"])
      ]))
    }), 128)),
    (_unref(postsData).posts.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: (_value, _refs) => {
            _refs['lastPost'] = _value
            lastPost.value = _value
          }
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(postsData).loadingPosts)
      ? (_openBlock(), _createBlock(PostSkeleton, { key: 1 }))
      : _createCommentVNode("", true),
    (!_unref(postsData).loadingPosts && _unref(postsData).posts?.length === 0 && !_unref(route).query?.keyword && !nextPostToken.value)
      ? (_openBlock(), _createBlock(NoPost, { key: 2 }))
      : _createCommentVNode("", true),
    (!_unref(postsData).loadingPosts && _unref(postsData).posts?.length === 0 && _unref(route).query?.keyword && !nextPostToken.value)
      ? (_openBlock(), _createBlock(NoResultFound, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(CreatePostModal),
    (currentPostId.value)
      ? (_openBlock(), _createBlock(EditPostModal, {
          key: 4,
          post: _unref(postsData).posts.find((e) => e.id === currentPostId.value)
        }, null, 8, ["post"]))
      : _createCommentVNode("", true),
    _createVNode(DeletePostModal, {
      postId: currentPostId.value,
      paramGetPost: paramGetPost.value
    }, null, 8, ["postId", "paramGetPost"]),
    _createVNode(DeletePostSuccessModal),
    _createVNode(InterestModal),
    _createVNode(InterestConfirmModal, {
      ref: (_value, _refs) => {
        _refs['interestConfirmModal'] = _value
        interestConfirmModal.value = _value
      },
      "on-confirm": (p) => handleLikeOrInterest('interest', p)
    }, null, 8, ["on-confirm"]),
    _createVNode(MessageModal, {
      id: _unref(MODAL_ID).INTEREST_COMPLETE,
      header: _unref(translate)('OF10completeTitle'),
      contentMessage: _unref(translate)('OF10completeMessage1'),
      subContentMessage: _unref(translate)('OF10completeMessage2')
    }, null, 8, ["id", "header", "contentMessage", "subContentMessage"]),
    _createVNode(LikeModal),
    _createVNode(CreateCommentModal),
    _createVNode(DeleteCommentModal, {
      onShowDeleteCommentSuccessModal: showDeleteCommentSuccessModal,
      postId: deleteTargetPostId.value,
      postCommentId: deleteTargetPostCommentId.value,
      commentPublishedFlg: deleteTargetCommentPublished.value
    }, null, 8, ["postId", "postCommentId", "commentPublishedFlg"]),
    _createVNode(DeleteCommentSuccessModal, { "is-delete": commentIsDelete.value }, null, 8, ["is-delete"])
  ], 64))
}
}

})